import { join, pipe, props, trim } from 'ramda';

export const getFullName = pipe(
  props(['firstName', 'lastName']),
  join(' '),
  trim,
);
